import * as React from 'react';
import classNames from 'classnames';

// Utils
import { getOperatedVehicle } from '@src/shared/src/util/trips';
import { getVehicleIcon } from '@toolkit/util/app';

// Models
import { TransportSegmentModel } from '@src/shared/src/models';

type Props = {
  transportSegment: TransportSegmentModel;
};

export const TransportSegmentIcon: React.FC<Props> = ({ transportSegment }) =>
  transportSegment.iconURL ? (
    <img className="product-icon" src={transportSegment.iconURL} />
  ) : (
    <i className={classNames('icon', getVehicleIcon(getOperatedVehicle(transportSegment)))} />
  );
